import { render, staticRenderFns } from "./BetslipHistory.vue?vue&type=template&id=142ce154&scoped=true"
import script from "./BetslipHistory.vue?vue&type=script&lang=js"
export * from "./BetslipHistory.vue?vue&type=script&lang=js"
import style0 from "./BetslipHistory.vue?vue&type=style&index=0&id=142ce154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142ce154",
  null
  
)

export default component.exports